<section class="pt-5 pb-5">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h3 class="mb-3">Stride Listings</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="card">
                    <img
                        class="card-img-top"
                        src="https://stride-real-estate.s3.amazonaws.com/1603752827667Capture.JPG"
                        alt="Card image cap"
                    />
                    <div class="card-body">
                        <h5 class="card-title">7825 Mccallum Blvd</h5>
                        <h6 class="card-text">
                            Dallas, Texas - 75252
                        </h6>
                        <a href="#!" class="btn btn-primary">Details</a>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card">
                    <img class="card-img" src="https://stride-real-estate.s3.amazonaws.com/1603752827667Capture.JPG" alt="Card image">
                    <div class="card-img-overlay">
                        <div class="property-details">
                            <p class="card-text">I'm text that has a background image!</p>
                        </div>
                      
                    </div>
                  </div>
            </div>
        </div>
    </div>
</section>
